import { SiteFooter } from "../Landing/site/SiteFooter";
import { AUDIENCE_LINKS } from "../Landing/site/siteConfig";

/** Footer for the /info/* guides. Uses the default SUPPORT_PHONE (844-FLIPIQ) so it matches the header. */
const InfoFooter = () => (
  <SiteFooter
    columns={[
      { title: "For you", links: AUDIENCE_LINKS.map(({ label, href }) => ({ label, href })) },
      {
        title: "Learn more",
        links: [
          { label: "Our difference", href: "/info/our-difference" },
          { label: "FAQs", href: "/info/faqs" },
          { label: "About us", href: "/info/about-us" },
        ],
      },
      {
        title: "Account",
        links: [
          { label: "Get started", href: "/get-started" },
          { label: "Log in", href: "/signin" },
        ],
      },
    ]}
  />
);

export default InfoFooter;
